import { Box, HStack, Text, Separator, Button } from '@chakra-ui/react'
import { PaymentHeader } from '@!/User/Payment/components'
import CoinSubmitButton from './CoinSubmitButton'

export const PaymentForm = ({ newCardToken, currentCard, handleSubmit, onChangeCard }) => {
  return (
    <>
      <PaymentHeader />
      {!newCardToken && (
        <>
          <HStack w="100%" p="4" justify="space-between">
            <Text fontWeight="bold">前回使用したカード</Text>
            <Button size="xs" fontSize="2xs" onClick={onChangeCard}>
              他のカードを使う
            </Button>
          </HStack>
          <Separator />
        </>
      )}

      <HStack w="100%" justify="space-between" p="4" fontSize="2xs">
        <Text>クレジットカード番号</Text>
        <Text>{currentCard?.number}</Text>
      </HStack>

      <Separator />

      <Box w="100%" p="4">
        <CoinSubmitButton handleSubmit={handleSubmit} />
      </Box>
    </>
  )
}
